import barcodeMsg from './barcodeMsg';
import common from './common';
import font from './font';
import handelPanel from './handle-panel';
import preview from './preview';
import provider from './provider';
import setting from './setting';
import toolbar from './toolbar';

export default {
    ...barcodeMsg,
    ...common,
    ...font,
    ...handelPanel,
    ...preview,
    ...provider,
    ...setting,
    ...toolbar
};
